import React from "react";
import { AppRoutes, buildUrl } from "../AppRoutes";
import { matchPath, useLocation } from "react-router";
import { Link } from "react-router-dom";
import { useTranslation2 } from "../Contexts/TranslationContext2";

type BPMenuProps = {
    userName: string;
    roles: string[];
    isAllowed?: (policy: string) => boolean;
    onLogout?: () => void;
};

const defaultIsAllowed = () => true;

const BPMenu: React.FC<BPMenuProps> = ({
    userName,
    roles,
    isAllowed = defaultIsAllowed,
    onLogout,
}) => {
    const { translations: translation } = useTranslation2();
    const location = useLocation();

    const firstRole = roles?.[0] ?? "";

    const handleLogout = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        if (onLogout) {
            onLogout();
        }
    };

    const isActive = (route: string) => {
        return matchPath({ path: route, caseSensitive: false, end: true }, location.pathname) ? "active" : "";
    }

    const routes = [
        { name: translation.common.labs, route: AppRoutes.Lab, policy: "CanAccessLabs" },
        { name: translation.common.cases, route: AppRoutes.Case, policy: "CanAccessCases" },
        { name: translation.common.kits, route: AppRoutes.Kit, policy: "SiteAdmin" },
        { name: translation.common.populations, route: AppRoutes.Populations, policy: "CanManagePopulations" },
        { name: translation.common.users, route: AppRoutes.User, policy: "CanManageUsers" },
        { name: translation.common.roles, route: AppRoutes.Roles, policy: "SiteAdmin" },
        { name: translation.common.samples, route: AppRoutes.Profiles, policy: "CanAccessSamples" },
        { name: translation.common.profiles, route: AppRoutes.ProfilesMetadata, policy: "CanAccessEnrollments" },
        { name: translation.common.workQueue, route: AppRoutes.WorkQueue, policy: "CanAccessWorkQueue" },
    ];

    return (
        <div className="ui menu">
            <div className="ui container">
                <a className="header item" href="/">
                    <i className="smalllogo icon" />
                </a>

                {routes.map(r => (
                    isAllowed(r.policy) && (
                        <Link key={r.route} className={`item ${isActive(r.route)}`} to={buildUrl(r.route as any, {})}>{r.name}</Link>
                    )
                ))}

                {/* {isAllowed("CanAccessLabs") && (
                    <a className={`item ${isActive(AppRoutes.Lab)}`} href={buildUrl(AppRoutes.Lab, {})}>
                        {translation.common.labs}
                    </a>
                )}
                {isAllowed("CanAccessCases") && (
                    <a className={`item ${isActive(AppRoutes.Case)}`} href={buildUrl(AppRoutes.Case, {})}>
                        {translation.common.cases}
                    </a>
                )}
                {isAllowed("SiteAdmin") && (
                    <a className={`item ${isActive(AppRoutes.Kit)}`} href={buildUrl(AppRoutes.Kit, {})}>
                        {translation.common.kits}
                    </a>
                )}
                {isAllowed("CanManagePopulations") && (
                    <a className={`item ${isActive(AppRoutes.Populations)}`} href={buildUrl(AppRoutes.Populations, {})}>
                        {translation.common.populations}
                    </a>
                )}
                {isAllowed("CanManageUsers") && (
                    <a className={`item ${isActive(AppRoutes.User)}`} href={buildUrl(AppRoutes.User, {})}>
                        {translation.common.users}
                    </a>
                )}
                {isAllowed("SiteAdmin") && (
                    <a className={`item ${isActive(AppRoutes.Roles)}`} href={buildUrl(AppRoutes.Roles, {})}>
                        {translation.common.roles}
                    </a>
                )}
                {isAllowed("CanAccessSamples") && (
                    <a className={`item ${isActive(AppRoutes.Profiles)}`} href={buildUrl(AppRoutes.Profiles, {})}>
                        {translation.common.samples}
                    </a>
                )}
                {isAllowed("CanAccessEnrollments") && (
                    <a className={`item ${isActive(AppRoutes.ProfilesMetadata)}`} href={buildUrl(AppRoutes.ProfilesMetadata, {})}>
                        {translation.common.profiles}
                    </a>
                )}
                {isAllowed("CanAccessWorkQueue") && (
                    <a className={`item ${isActive(AppRoutes.WorkQueue)}`} href={buildUrl(AppRoutes.WorkQueue, {})}>
                        {translation.common.workQueue}
                    </a>
                )} */}

                <div className="right menu">
                    <div className="ui item userBlock">
                        <div className="userName">
                            <a href={buildUrl(AppRoutes.ManageProfile, {})}>{userName}</a>
                        </div>
                        <div className="role">{firstRole}</div>
                    </div>
                    <div className="ui item">
                        <div className="ui form" >
                            <button
                                type="button"
                                className="ui mini basic button"
                                onClick={handleLogout}
                            >
                                {translation.common.logOut}
                            </button>

                            {isAllowed("SiteAdmin") && (
                                <Link
                                    className="ui button mini basic left icon"
                                    to={buildUrl(AppRoutes.AppSettings, {})}
                                    title={translation.common.appSettings}
                                >
                                    <i className="icon setting" />
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BPMenu;

